import { useCallback } from 'react';

import { expValEquals } from '@confluence/feature-experiments';

import { createMarkdownFolder, findRootMarkdownFolder } from '../services/MarkdownFolderService.ts';
import { MarkdownImportError } from '../services/MarkdownImportService.ts';

export type ResolveMarkdownFolderInput = {
	spaceId: string;
	spaceKey: string;
	folderName: string;
	signal: AbortSignal;
};

export type ResolveMarkdownFolder = (input: ResolveMarkdownFolderInput) => Promise<string>;

export const useMarkdownFolderResolver = (): ResolveMarkdownFolder => {
	return useCallback(async ({ spaceId, spaceKey, folderName, signal }) => {
		if (signal.aborted) {
			throw new MarkdownImportError('aborted');
		}

		if (!expValEquals('twcg_2627_markdown_file_import_into_confluence', 'isEnabled', true)) {
			throw new MarkdownImportError('experiment_disabled');
		}

		const existingFolderId = await findRootMarkdownFolder({
			spaceKey,
			title: folderName,
			signal,
		});
		if (signal.aborted) {
			throw new MarkdownImportError('aborted');
		}

		if (existingFolderId) {
			return existingFolderId;
		}

		return createMarkdownFolder({ spaceId, title: folderName, signal });
	}, []);
};
